import Vue from 'vue';

const EventUtils = {

    getEvents(offset, limit, dateStart, dateFinish, str) {
        return Vue.axios
            .get(`event`, {
                params: {
                    offset: offset,
                    limit: limit,
                    start: dateStart.getTime(),
                    finish: dateFinish.getTime(),
                    search: str
                }
            })
            .then(response => {
                console.log('return events total:' + response.data.total + ', current:' + response.data.data.length);
                return response.data;
            });
    },
    createEvent(event) {
        return Vue.axios.put('event', event);
    },
    updateEvent(event) {
        return Vue.axios.post('event', event);
    },
    DELETE(id) {
        return Vue.axios.delete('event/' + id);
    },
    getIntervals() {
        return Vue.axios.get('event/interval');
    }

}

export default EventUtils;
